(ns ycweb.app.website.school.quiz.detail
  (:require
   [rum.core :as rum]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc quiz < rum/reactive [app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        module-atom (rum/cursor-in state-atom [:module])
        module (rum/react module-atom)
        user (cmn/curact state-atom [:user])
        quiz-atom (rum/cursor-in module-atom [:module/quiz])
        quiz (rum/react quiz-atom)

        {:module/keys [course-uuid user-module-uuid course-title position]} module]
    [:main
     {:id "main-content" :class (u/bem :yc-page-content [:medium])}
     [:div
      {:class (u/bem :yc-section [:medium-underline])}
      [:div.u-block-center.u-max-width-720
       [:ul.breadcrumbs.group
        [:li.breadcrumbs__item
         [:a.breadcrumb__link
          (urlstate/href-props app-atom "cooking-school" "my-courses" {})
          "My Courses"]]
        [:li.breadcrumbs__item
         [:a.breadcrumb__link
          (urlstate/href-props app-atom "cooking-school" "mycourseview" {:uuid course-uuid})
          course-title]]
        [:li
         {:class (u/bem :breadcrumbs__item [:always-show])}
         [:a.breadcrumb__link
          (urlstate/href-props app-atom "cooking-school" "moduleview" {:uuid user-module-uuid})
          (str "Lesson " position)
          [:span.clip-text.unclip-text--m ": " (:ent/display-name module)]]]
        [:li.breadcrumbs__item
         [:span.breadcrumb__current-text "Quiz"]]]
       (headings/heading (str "Quiz: " (:ent/display-name module))
         {:type :h1
          :size :large})
       [:p
        {:class (u/bem :yc-paragraph [:flush])}
        "You need a score of 80% or higher to complete this step.
         You can take the quiz as many times as you want. Take a deep breath and start in your own time.
         We believe in you, "
        (when (u/presence (:ent/display-name user)) (str (:ent/display-name user) ", "))
        "you can do it!"]]]

     [:div.u-block-center.u-max-width-480
      {:class (u/bem :yc-section [:large])}
      (map
        (fn [[question-uuid {:ent/keys [display-name] :question/keys [selected-option-uuid correct? options]}]]
          [:div.form-section
           {:key question-uuid}
           [:p.yc-paragraph
            (cond
              (and
                (:quiz/user-answers? quiz)
                (u/presence selected-option-uuid)
                (not correct?))
              {:class "text-status--error"}

              (and
                (:quiz/user-answers? quiz)
                (u/presence selected-option-uuid)
                correct?)
              {:class "text-status--success"})
            [:b display-name]]
           (map
             (fn [option]
               [:div.form-field
                {:key (:ent/uuid option)}
                (input-forms/radio
                  (:ent/display-name option)
                  (:ent/uuid option)
                  (rum/cursor-in quiz-atom [:quiz/questions question-uuid :question/selected-option-uuid]))])
             (sort-by :option/position options))])
        (sort-by (comp :question/position second) (:quiz/questions quiz)))

      [:div.form-control
       (buttons/button-web "Submit answers"
         {:on-click #(grid/dispatch-action app-atom :web.cooking-school/quizsubmit {})
          :type :button
          :style :primary
          :size :default})]]
     (toaster/loading-overlay app-atom :web.cooking-school/quizview)]))

(defmethod flow/render-screen :web.cooking-school/quizview [app-atom _]
  (website/screen-wrapper app-atom
    (quiz app-atom)
    {:pagetype :school}))

(defmethod t/transition-open :web.cooking-school/quizview [app-atom _ params]
  (toaster/open-overlay app-atom :web.cooking-school/quizview)
  (swap! (cmn/action-cursor app-atom) assoc :module nil :quiz-uuid (:uuid params))
  (comms/ajax-get :web.cooking-school/quizview {:ent/uuid (:uuid params)}))

(defmethod comms/receive :web.cooking-school/quizview [app-atom e]
  (toaster/close-overlay app-atom :web.cooking-school/quizview)

  (swap!
    (cmn/action-cursor app-atom) assoc
    :module (:module e)
    :user (:user e)))

(defmethod grid/action :web.cooking-school/quizsubmit [app-atom config _]
  (let [state-atom (cmn/action-cursor app-atom)
        quiz-uuid (cmn/curact state-atom [:quiz-uuid])
        user-module-uuid (cmn/curact state-atom [:module :module/user-module-uuid])
        user-quiz (cmn/curact state-atom [:module :module/quiz :quiz/user-quiz])

        questions
        (->>
          (cmn/curact state-atom [:module :module/quiz :quiz/questions])
          (map
            (fn [[_ question]]
              (->
                question
                (select-keys [:ent/uuid :question/selected-option-uuid]))))
          (filter #(u/presence (:question/selected-option-uuid %)))
          (vec))]

    (toaster/open-toast app-atom :processing "Submitting answers" {:closetime 10000})
    (comms/ajax-post :web.cooking-school/quizsubmit
      {:quiz
       {:ent/uuid quiz-uuid
        :quiz/user-module-uuid user-module-uuid
        :quiz/questions questions
        :quiz/user-quiz user-quiz}}))

  (defmethod comms/receive :web.cooking-school/quizsubmit [app-atom e]
    (toaster/close-toast app-atom)
    (urlstate/redirect app-atom "cooking-school" "quizscore" {:uuid (:ent/uuid (:quiz e))})))
